var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "custom-select",
      attrs: { tabindex: _vm.tabindex },
      on: {
        blur: function ($event) {
          _vm.open = false
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "selected",
          class: { open: _vm.open },
          on: {
            click: function ($event) {
              _vm.open = !_vm.open
            },
          },
        },
        [_vm._v(" " + _vm._s(_vm.$t(_vm.selected)) + " ")]
      ),
      _c(
        "div",
        { staticClass: "items", class: { selectHide: !_vm.open } },
        _vm._l(_vm.options, function (option, i) {
          return _c(
            "div",
            {
              key: i,
              class: { active: option.label === _vm.selected },
              on: {
                click: function ($event) {
                  _vm.selected = option.label
                  _vm.open = false
                  _vm.$emit("update", option.value)
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t(option.label)) + " ")]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }